import React from 'react';
import { IconProps } from '@/models/IconProps';

const WarningIcon: React.FC<IconProps> = ({ height = '24', width = '24', strokeColor = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8627 7.87963C12.8731 7.39691 12.4846 7 12.0018 7C11.5192 7 11.1308 7.39656 11.1408 7.87907L11.2527 13.2536C11.2612 13.6603 11.5933 13.9855 12 13.9855C12.4066 13.9855 12.7386 13.6606 12.7473 13.2541L12.8627 7.87963Z"
        fill={strokeColor}
      />
      <path
        d="M11.2909 16.691C11.4879 16.8971 11.7242 17.0002 12 17.0002C12.1818 17.0002 12.347 16.9535 12.4955 16.8601C12.647 16.7635 12.7682 16.6347 12.8591 16.4736C12.953 16.3126 13 16.1339 13 15.9374C13 15.6475 12.9 15.3996 12.7 15.1934C12.503 14.9873 12.2697 14.8843 12 14.8843C11.7242 14.8843 11.4879 14.9873 11.2909 15.1934C11.097 15.3996 11 15.6475 11 15.9374C11 16.2337 11.097 16.4849 11.2909 16.691Z"
        fill={strokeColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z"
        fill={strokeColor}
      />
    </svg>
  );
};

export default WarningIcon;
